export enum INTERLEAVE_MODE {
    EVENT = 'event',
    KEY_MOMENT = 'key_moment',
}

interface OpenerCloserCoverTechnicalParameters {
    mode: INTERLEAVE_MODE,
    margin_sx: number,
    margin_dx: number,
    offset: number,
    position: 'sx' | 'dx'
}

export interface ColumnOption {
    name: string;
    label: string;
}

export interface ColumnDef {
    name: string;
    label: string;
    type: string;
    width?: number;
    flex?: number;
    options?: ColumnOption[];
}

export interface HeaderDef {
    text: string;
    icon?: {
        position: 'left' | 'right';
    };
}

type FieldAppType = 'string' | 'number' | 'int' | 'date' | 'multistring' | 'datagrid';

export interface EditorialAssetRenderParameters {
    name: string,
    app_type: FieldAppType,
    plat_type: string
    label?: string
    columns?: ColumnDef[]
    header?: HeaderDef
}

export enum EDITORIAL_CATEGORY {
    OPENING = 'opening',
    CLOSING = 'closing',
    INTERLEAVE = 'mid',
    WATERMARK = 'watermark',
}

export enum EDITORIAL_ASSETS {
    OPENING_COVER = 'opening_cover',
    CLOSING_COVER = 'closing_cover',
    INTERLEAVE = 'interleave',
    WATERMARK = 'watermark',
    POPUP = "popup",
    PRE_ROLL = 'pre_roll',
    POST_ROLL = 'post_roll'
}

export interface EditorialAsset {
    id: string;
    name: string;
    type: string;
    competition: string;
    duration: number;
    content_type: string;
    category: string;
    placement_type: EDITORIAL_ASSETS;

    thumbnail_path: string;
    preview_path: string;

    // nuove label
    category_label?: string;
    type_label?: string;
    placement_type_label?: string;
    aspect_ratio: number;

    parameters: {
        technical_parameters: OpenerCloserCoverTechnicalParameters;

        production_parameters: {
            fps: number;
            width: number;
            height: number;
            inSeconds: number;
            outSeconds: number;
            holdSeconds: number;
        };

        render_parameters: EditorialAssetRenderParameters[];
    };
}


export interface EditorialAdditionalInfo {
    logo: string,
    label:string
}

export interface OverlayRenderParametersResponse {
    overlay_params: any,
    overlay_render: any,
    infos: Record<string, EditorialAdditionalInfo>,
    placementType?: string,
    url?: string,
}
export interface AssetMaterializationResult {
    path: string, 
    url: string,
    id: string,
    placementType: string,
}